import { createSelector } from 'reselect'
import { selectApplication } from './selectApplication'

// Monotonic counter bumped each time a copilot draft is requested. The
// HelplyCopilotPanel watches it to forward a `draft` command into the iframe.
export const selectHelplyCopilotDraftNonce = createSelector(
  selectApplication,
  app => app.helplyCopilotDraftNonce
)
